/**
 * 默认字号
 * 基础类型默认16
 * 标签类型默认14
 */
export const kDefaultFontSize = {
    base: 16,
    label: 14
};
/**
 * 默认item高度
 */
export const kDefaultItemHeight = {
    base: 50,
    label: 40
};
/**
 * item wrapp padding
 */
export const kLableWrapperPadding = 10;
/**
 * 标签Item上下左右margin值
 */
export const kLabelItemMargin = 5;
